import * as actionTypes from "../actions/actionTypes";

const initialState = {
  mainHmgSelected: undefined,
  hmgSelected: undefined,
  hotelSelected: undefined,
  hotelListSelected: [],
  projectListSelected: [],
};

export const common = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COMMON_SET_MAIN_HMG:
      return {
        ...state,
        mainHmgSelected: action.value,
      };
    case actionTypes.COMMON_SET_HMG:
      return {
        ...state,
        hmgSelected: action.value,
      };
    case actionTypes.COMMON_SET_SINGLE_HOTEL:
      return {
        ...state,
        hotelSelected: action.value,
      };
    case actionTypes.COMMON_SET_HOTEL_LIST:
      return {
        ...state,
        hotelListSelected: action.value,
      };
    case actionTypes.COMMON_SET_PROJECT_LIST:
      return {
        ...state,
        projectListSelected: action.value,
      };
    default:
      return state;
  }
};

export default common;
